import React from 'react'
import { StandardLocalWidget, fromJSX } from 'widgets-for-react'
import { ViewListenerState } from '../../viewListener/viewListenerState'
import { MainCategory } from '../filtersLoader/filtersLoaderState'
import { TopFilters } from '../filtersUtils'
import { CategoriesFilterLayout } from './categoriesFilterLayout'
import { CategoriesFilterState } from './categoriesFilterState'
import { CategoriesSelection } from './categoriesFilterUtils'

export const categoriesFilterWidget =
  (
    topFilters: TopFilters,
    categories: MainCategory[],
    selectedCategories: CategoriesSelection,
    viewListenerState: ViewListenerState,
    paywalled: boolean
  ): StandardLocalWidget<CategoriesFilterState> =>
  (state) =>
    fromJSX((setState) => (
      <CategoriesFilterLayout
        topFilters={topFilters}
        viewListenerState={viewListenerState}
        selectedCategories={selectedCategories}
        categories={paywalled ? categories.slice(0, 2) : categories}
        expandedCategories={state}
        updateExpandedCategories={(categories) => setState(() => categories)}
      />
    ))
